class CartNotification extends HTMLElement {
  oldHeader = null;
  headerBar = null;

  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.oldHeader = document.querySelector('sticky-header');
    this.headerBar = document.querySelector('header-bar');

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // Custom: Disable default cart notification
    // this.notification.classList.add('animate', 'active');

    // this.notification.addEventListener(
    //   'transitionend',
    //   () => {
    //     this.notification.focus();
    //     trapFocus(this.notification);
    //   },
    //   { once: true }
    // );

    // document.body.addEventListener('click', this.onBodyClick);

    // Custom
    this.openShopTheLookModal();
  }

  openShopTheLookModal() {
    const variantId = this.variantIdInput?.value;
    if (variantId) {
      this.updateShopTheLookAddedProduct(variantId);
    }
    window.location.href = '#shop-the-look';
  }

  updateShopTheLookAddedProduct(variantId) {
    const dataScript = document.querySelector('[data-shop-the-look-product-data]');
    if (!dataScript) return;

    try {
      const productData = JSON.parse(dataScript.textContent);
      const variant = productData.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      const imageEl = document.querySelector('[data-stl-added-image]');
      const priceEl = document.querySelector('[data-stl-added-price]');

      if (imageEl) {
        if (variant.featured_image) {
          imageEl.src = variant.featured_image.src;
          imageEl.alt = variant.featured_image.alt || productData.title;
        } else if (productData.featured_image) {
          imageEl.src = productData.featured_image;
        }
      }

      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price, productData.money_format);
      }
    } catch (e) {
      console.error('Failed to update shop-the-look added product:', e);
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.oldHeader) this.oldHeader.reveal();
    if (this.headerBar) this.headerBar.show();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
